/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Converter_DescriptionInputs */

const en_project_converter_description = /** @type {(inputs: Project_Converter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter By CC Converter`)
};

const fr_project_converter_description = /** @type {(inputs: Project_Converter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti par CC Converter`)
};

const de_project_converter_description = /** @type {(inputs: Project_Converter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konverter von CC Converter`)
};

const it_project_converter_description = /** @type {(inputs: Project_Converter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di CC Converter`)
};

const ru_project_converter_description = /** @type {(inputs: Project_Converter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конвертер от CC Converter`)
};

const es_project_converter_description = /** @type {(inputs: Project_Converter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor de CC Converter`)
};

const zh_cn2_project_converter_description = /** @type {(inputs: Project_Converter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CC转换器`)
};

const ja_project_converter_description = /** @type {(inputs: Project_Converter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCコンバーターによるコンバーター`)
};

const hi_project_converter_description = /** @type {(inputs: Project_Converter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सीसी कन्वर्टर द्वारा कन्वर्टर`)
};

const pt_pt2_project_converter_description = /** @type {(inputs: Project_Converter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor por CC Converter`)
};

/**
* | output |
* | --- |
* | "Converter By CC Converter" |
*
* @param {Project_Converter_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_converter_description = /** @type {((inputs?: Project_Converter_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Converter_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_converter_description(inputs)
	if (locale === "de") return de_project_converter_description(inputs)
	if (locale === "it") return it_project_converter_description(inputs)
	if (locale === "ru") return ru_project_converter_description(inputs)
	if (locale === "es") return es_project_converter_description(inputs)
	if (locale === "zh-CN") return zh_cn2_project_converter_description(inputs)
	if (locale === "ja") return ja_project_converter_description(inputs)
	if (locale === "hi") return hi_project_converter_description(inputs)
	if (locale === "pt-PT") return pt_pt2_project_converter_description(inputs)
	return en_project_converter_description(inputs)
});